<div (window:resize)="windowResized()"  #submenu class="submenu__wrapper">
	<user-toggle-status
		(onChangeStatus)="trackToggle($event);onChangeStatus.emit($event)"
		[isUserVisible]="isUserVisible"
	></user-toggle-status>
	<freud-menu [items]="menuItems"></freud-menu>
</div>
